import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    flash: String
  }
  connect() {
    const url = new URL(location);
    const internal_mode = url.searchParams.get("internal_mode")
    console.log(this.flashValue)
    if (!internal_mode || this.flashValue == "notice" ){
    setTimeout(() => {
      this.dismiss();
    }, 5000);
  }
  }

  dismiss() {
    this.element.classList.add("fade-out");
    setTimeout(() => {
      this.element.remove();
    }, 500);
  }
}
